import procedure from '@/components/examine/procedure.vue';
import schedule from '@/components/examine/schedule.vue';
import { auditScheduleResource } from '@/views/examine/typeManage/request';
import sharedNode from '@/views/examine/components/sharedNode.vue';
import claimsInfo from './recordFrom/claimsInfo.vue';
import { auditSchedule, auditDetail } from './request';
export default {
  components: {
    procedure,
    schedule,
    sharedNode,
    claimsInfo
  },
  data() {
    return {
      scheduleList: [],
      procedureList: [],
      step: 0,
      scheduleInfo: {},
      detailsObj: null
    };
  },
  created() {
    this.getInfoFun();
  },
  methods: {
    async getInfoFun() {
      const res = await auditScheduleResource({
        auditFlowTypeId: this.$route.params.auditFlowTypeId
      });
      if (res.length != 0) {
        this.procedureList = res;
        this.procedureList.unshift({
          iconName: 'container',
          id: -1,
          name: '报案理赔'
        });
      }
      this.getscheduleFun();
    },
    async getscheduleFun() {
      this.scheduleList = await auditSchedule({
        auditFlowDetailId: this.$route.params.id,
        flowMark: 'claims'
      });
      console.log(this.scheduleList);
      this.scheduleInfo = this.scheduleList[this.scheduleList.length - 1];
      if (!this.scheduleInfo.currentScheduleOperator && !this.scheduleInfo.operationAt && this.scheduleInfo.step == '0') {
        this.scheduleInfo = this.scheduleList[this.scheduleList.length - 2];
      }
      this.step = this.procedureList.findIndex(val => {
        return val.id == this.scheduleInfo.auditFlowScheduleId;
      });
      if (this.step == -1) {
        this.step = 0;
      }
      this.detailFun();
    },
    goInfoFun(val) {
      this.scheduleInfo = val;
      this.detailFun();
    },
    async detailFun() {
      this.detailsObj = null;
      const res = await auditDetail({
        auditScheduleId: this.scheduleInfo.id,
        flowMark: 'claims'
      });
      console.log(res);
      this.detailsObj = res;
    }
  }
};